var map = {
	"./modules/authorization/authorization.module": [
		"./src/app/modules/authorization/authorization.module.ts",
		"common",
		"modules-authorization-authorization-module"
	],
	"./modules/contest-vote/contest-vote.module": [
		"./src/app/modules/contest-vote/contest-vote.module.ts",
		"modules-contest-vote-contest-vote-module"
	],
	"./modules/contest/contest.module": [
		"./src/app/modules/contest/contest.module.ts",
		"common",
		"modules-contest-contest-module"
	],
	"./modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"default~modules-dashboard-dashboard-module~modules-generate-name-steps-generate-name-steps-module",
		"common",
		"modules-dashboard-dashboard-module"
	],
	"./modules/generate-name-steps/generate-name-steps.module": [
		"./src/app/modules/generate-name-steps/generate-name-steps.module.ts",
		"default~modules-dashboard-dashboard-module~modules-generate-name-steps-generate-name-steps-module",
		"common",
		"modules-generate-name-steps-generate-name-steps-module"
	],
	"./modules/profile/profile.module": [
		"./src/app/modules/profile/profile.module.ts",
		"common",
		"modules-profile-profile-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;